import React, { useState, useEffect, useContext } from 'react';
import { Widget, usePromise, Table, Button, ButtonDelete } from '@digital/ui';
import { Icon, Collapse, Descriptions } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import {
  getAllCartaNomeacaoPorUsuarioId,
  CartaNomeacao,
  verificarSeUsuarioSelecionadoEGestor,
  getFileCartaNomeacaoById,
  excluirArquivoCartaNomeacao,
  viewFileCartaNomeacaoById,
} from '../../api/usuario';
import ComponeteCurso from '../../components/componeteCurso';
import { Tooltip } from 'antd';
import { GetFileExtension, getLoggedIsMRN, imageFormats } from '@app/helpers';
import { baixarTemplateNomeacaoGestorFornecedor } from '@app/api/template';
const { Panel } = Collapse;
interface PropCartaNomeacao {
  usuarioId: string;
  atualizarInformacoes: boolean;
}

const CreatCartaNomeacao = (props: PropCartaNomeacao) => {
  const { usuarioId, atualizarInformacoes } = props;
  const [listCartaNomeacao, setListCartaNomeacao] = useState<CartaNomeacao[]>();
  const [carregarTabela, setCarregarTabela] = useState<boolean>(true);
  const [usuarioSelecionadoEGestor, setUsuarioSelecionadoEGestor] = useState<boolean>(false);
  const [atualizarExcluir, setAtualizarExcluir] = useState<boolean>(false);
  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  useEffect(() => {
    CarregarDados();
  }, [carregarTabela, atualizarInformacoes, atualizarExcluir, usuarioId]);

  const CarregarDados = async () => {
    const result = await getAllCartaNomeacaoPorUsuarioId(usuarioId);
    if (result) {
      setListCartaNomeacao(result);
    }
    const usuarioEGestor = await verificarSeUsuarioSelecionadoEGestor(usuarioId);
    if (usuarioEGestor === null) {
      setUsuarioSelecionadoEGestor(false);
    } else {
      if (usuarioEGestor != undefined) {
        setUsuarioSelecionadoEGestor(usuarioEGestor);
      } else {
        setUsuarioSelecionadoEGestor(false);
      }
    }
  };

  const excluirArquivo = async (arquivoId: string) => {
    const result = await excluirArquivoCartaNomeacao(arquivoId);
    if (result) {
      setAtualizarExcluir(!atualizarExcluir);
    }
  };

  const baixarArquivo = (arquivoId: string, nomeDoArquivo: string) => {
    getFileCartaNomeacaoById(arquivoId, nomeDoArquivo);
  };

  const viewArquivo = (arquivoId: string, nomeDoArquivo: string) => {
    viewFileCartaNomeacaoById(arquivoId, nomeDoArquivo);
  };

  const columns = [
    {
      title: 'Número',
      dataIndex: 'numero',
      width: '5%',
    },
    {
      title: 'Nome',
      dataIndex: 'nome',
      width: '20%',
    },
    {
      title: 'Inclusão',
      dataIndex: 'dataInclusaoFormatada',
      width: '20%',
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      width: '20%',
    },
    {
      title: 'Ações',
      dataIndex: '',
      key: 'x',
      width: '5%',
      render: record => (
        <>
          {isMRN ? (
            <>
              <Tooltip title="Deletar Item">
                <ButtonDelete
                  onClick={() => {
                    excluirArquivo(record.id);
                  }}
                  name="btnExcluirItem"
                  icon="science-minus"
                  confirm="Deseja realmente excluir este registro?"
                  okText="Confirmar"
                  className="btn-delete-without-text"
                />
              </Tooltip>
              <Tooltip title="Baixar Arquivo">
                <Button
                  onClick={() => {
                    baixarArquivo(record.id, record.nome);
                  }}
                  icon="ui-download"
                  name="btnBaixarArquivo"
                />
              </Tooltip>
              {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                <Tooltip title="Visualizar Arquivo">
                  <Button
                    onClick={async () => {
                      await viewArquivo(record.id, record.nome);
                    }}
                    icon="files-view_file"
                    name="btnViewArquivo"
                  />
                </Tooltip>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              <>
                <Tooltip title="Baixar Arquivo">
                  <Button
                    onClick={() => {
                      baixarArquivo(record.id, record.nome);
                    }}
                    icon="ui-download"
                    name="btnBaixarArquivo"
                  />
                </Tooltip>
                {GetFileExtension(record.nome) === 'pdf' || imageFormats.includes(GetFileExtension(record.nome)) ? (
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      onClick={async () => {
                        await viewArquivo(record.id, record.nome);
                      }}
                      icon="files-view_file"
                      name="btnViewArquivo"
                    />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </>
            </>
          )}
        </>
      ),
    },
  ];

  return usuarioSelecionadoEGestor ? (
    <>
      <fieldset>
        <legend>Carta de nomeação de Gestor do Contrato</legend>
      </fieldset>
      <Widget>
        <p>
          As ações de aprovação das medições de serviço serão realizadas pelo usuário Gestor no Sistema de Gestão de
          Contratos - SGC, ou seja, as aprovações realizadas no sistema estão munidas de força suficiente à validação
          das medições de serviço.
        </p>
        <p>
          Para tanto, deverá ser anexada uma Carta de Nomeação de Gestor do Contrato devidamente assinada por um
          representante legal da empresa para a ativação deste usuário. No caso de Minuta Contratual que traga a
          nomeação específica do Gestor do Contrato, a mesma é suficiente para a ativação.
        </p>
        <div className="ant-app-unboxed-button">
          <ComponeteCurso
            id={usuarioId}
            nomeIdFormulario={'usuarioId'}
            enderecoApi={'usuarios/updateCartaNomeacao'}
            descricaoBotao={'Incluir arquivo'}
            retorno={data => {
              if (data.valid) {
                setCarregarTabela(!carregarTabela);
              }
            }}
            idDoComponente={'update'}
          />

          <Tooltip title="Baixar template de carta de nomeação">
            <Button
              id={`mrn-button-download-template-nomeacao`}
              style={{ marginLeft: '10px' }}
              icon="ui-download"
              type="link"
              onClick={() => {
                baixarTemplateNomeacaoGestorFornecedor();
              }}
              title="Baixar Template"
              className="labeled"
            />
          </Tooltip>
        </div>

        <Table rowKey="id" columns={columns} dataSource={listCartaNomeacao} pagination={false} />
      </Widget>
    </>
  ) : (
    <> </>
  );
};

export default CreatCartaNomeacao;
